theme.footerSection = (function () {
  function footer() {
    // Mobile navigation bar
    const mobileNavigateBar = document.querySelector(
      ".mobile__navigation--bar"
    );
    if (mobileNavigateBar) {
      const updateMobileBarHeight = function () {
        if (window.innerWidth < 750) {
          const height = Math.max(mobileNavigateBar.clientHeight, 58);
          document.documentElement.style.setProperty(
            "--mobile-navigation-bar-height",
            `${height}px`
          );
        } else {
          document.documentElement.style.setProperty(
            "--mobile-navigation-bar-height",
            "0px"
          );
        }
      };
      updateMobileBarHeight();
      window.addEventListener("resize", updateMobileBarHeight, { passive: true });
    }
    // Footer widget column collapsible (Mobile accordion)
    let accordionBound = false;
    const footerWidgetAccordion = function () {
      if (accordionBound) return;
      accordionBound = true;

      document
        .querySelectorAll(".footer__widget_title")
        .forEach(function (title) {
          title.addEventListener("click", function (e) {
            // Only accordion on mobile (< 750px)
            if (window.innerWidth >= 750) return;

            // If user clicked an anchor link, don't toggle accordion
            if (e.target.tagName === "A") return;

            const footerWidget = this.closest(".footer__widget");
            if (!footerWidget) return;
            const footerWidgetInner = footerWidget.querySelector(
              ".footer__widget_inner"
            );
            if (!footerWidgetInner) return;

            if (footerWidget.classList.contains("active")) {
              footerWidget.classList.remove("active");
              if (typeof slideUp === "function") {
                slideUp(footerWidgetInner, 300);
              } else {
                footerWidgetInner.style.display = "none";
              }
            } else {
              footerWidget.classList.add("active");
              if (typeof slideDown === "function") {
                slideDown(footerWidgetInner, 300);
              } else {
                footerWidgetInner.style.display = "block";
              }

              // Close sibling widgets in the footer
              const parentRow = footerWidget.closest(".row");
              if (parentRow) {
                parentRow.querySelectorAll(".footer__widget.active").forEach(function (otherWidget) {
                  if (otherWidget !== footerWidget) {
                    otherWidget.classList.remove("active");
                    const otherInner = otherWidget.querySelector(".footer__widget_inner");
                    if (otherInner) {
                      if (typeof slideUp === "function") {
                        slideUp(otherInner, 300);
                      } else {
                        otherInner.style.display = "none";
                      }
                    }
                  }
                });
              }
            }
          });
        });
    };

    footerWidgetAccordion();

    window.addEventListener("resize", function () {
      if (window.innerWidth >= 750) {
        document.querySelectorAll(".footer__widget").forEach(function (item) {
          item.classList.remove("active");
          const inner = item.querySelector(".footer__widget_inner");
          if (inner) {
            inner.style.removeProperty("display");
            inner.style.removeProperty("height");
            inner.style.removeProperty("overflow");
          }
        });
      }
    });
  }
  return footer;
})();
